/**
 * An array representing the different pick types possible.
 *
 * @remarks Because the index of each value is tied to
 * an option of type `number` on the server,
 * **the order of the strings should not be changed**.
 */
export const pickTypeLabels = ['Strip', 'Size', 'Special'];
